export const environment = {
  production: false,
  envName: 'TESTING',
  // apiUrl: 'https://testing-api.drinkhopping.com/api/v1/'
  apiUrl: 'https://testing-drinkhopping-api-zvzp.onrender.com/api/v1/'
};
